import { atom } from 'recoil'
import { Language } from '~/types/api/users'

export const myLanguageState = atom<Language | undefined>({
  key: 'my_language',
  default: undefined,
})
